import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ACCOUNT, WALLET, SHOP } from '../../../constants';
import style from '../../../style/components/profile/preferences/WalletDefaultHomepage.module.scss';

const WalletDefaultHomepage = ({ value, disabled, onChange }) => {
  const { t } = useTranslation();
  const governmentId = 'wallet-homepage-government';
  const shopId = 'wallet-homepage-shop';

  const labelId = 'wallet-default-homepage-label';

  // The backend renamed the Government homepage value from "account" to
  // "wallet"; some legacy stored values may still be "account". Treat both
  // as Government for the rendered checked state, but always submit "wallet"
  // when the user (re)selects the option.
  const isGovernment = value === WALLET || value === ACCOUNT;
  const isShop = value === SHOP;

  return (
    <div
      className={style.container}
      role="radiogroup"
      aria-labelledby={labelId}
    >
      <span id={labelId} className={style.label}>
        {t('walletPreferences.defaultHomepage')}
      </span>
      <div className={style.optionsRow}>
        <label className={style.option} htmlFor={governmentId}>
          <input
            type="radio"
            name="wallet-default-homepage"
            id={governmentId}
            value={WALLET}
            checked={isGovernment}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            className={style.radio}
          />
          <span className={style.radioLabel}>
            {t('walletPreferences.idmeGovernment')}
          </span>
        </label>
        <label className={style.option} htmlFor={shopId}>
          <input
            type="radio"
            name="wallet-default-homepage"
            id={shopId}
            value={SHOP}
            checked={isShop}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            className={style.radio}
          />
          <span className={style.radioLabel}>
            {t('walletPreferences.idmeShop')}
          </span>
        </label>
      </div>
    </div>
  );
};

WalletDefaultHomepage.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

WalletDefaultHomepage.defaultProps = {
  value: null,
  disabled: false,
};

export default memo(WalletDefaultHomepage);
